import React, {useState, useEffect, useCallback} from "react";
import { Link } from "react-router-dom";
import Menu from "./Menu";
import { useNavigate } from 'react-router-dom';
import Loading from "../Loading";
import { UserAuth } from "../../context/AuthContext";
import { RxExit } from 'react-icons/rx';
import { AiOutlineMenu } from 'react-icons/ai';
import { BiBookOpen } from 'react-icons/bi';
import { useTranslations } from "../../translations";
import LanguageSelector from "../LanguageSelector";

const Header = () => {
    const [toggle, setToggle] = useState(false);
    const [width, setWidth] = useState(null);
    const [show, setShow] = useState("");
    const [close, setClose] = useState("");
    const { logout, loading } = UserAuth();
    const navigate = useNavigate();
    const { t } = useTranslations();

    const handleLogout = useCallback(async () => {
        try {
            await logout();
            navigate('/');
            /* console.log('You are logged out') */
        } catch (e) {
            /* console.log(e.message); */
        }
    }, [logout, navigate]);

    useEffect(() => {
        const handleWindowResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleWindowResize);
        /* console.log(width); */
        if(width<768){ 
            setShow("");
            setClose(<a className="navbar-brand col-md-3 col-lg-2 me-0 px-3 text-link-2" href="#" onClick={handleLogout}><RxExit size={20}/></a>);
        }else{
            setClose(<a className="btn-4 btn-sm btn-outline-secondary px-3 pt-2" href="#" onClick={handleLogout}>{t("logout")}</a>);
        }
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    },[width, toggle])

    useEffect(() => {
        if (toggle) {
            setShow("show");
        }else{
            setShow("");
        }
      
    }, [toggle])
    

    if(loading)
        return <Loading/>
        
    return (
        <>
            <header className="dashboard-header-modern border-0">
                <Link className="d-flex align-items-center d-md-none" to="/dashboard">
                    <img src="/assets/img/landing-images/MiABC-01.png" alt="MiABC Logo" style={{ height: "35px" }} />
                </Link>
                
                <button 
                    onClick={() => {setToggle(!toggle)}} 
                    className="btn-menu-modern d-md-none shadow-sm"
                >
                    <AiOutlineMenu size={24} />
                </button>
                
                <div className="d-none d-md-block fw-bold color-plum fs-5">
                    {/* Optional: Add page title or breadcrumbs here if needed, 
                        but for now let's keep it clean to fix alignment */}
                </div>

                <div className="ms-auto d-none d-md-flex align-items-center gap-3">
                    <Link to="/user-guide" className="btn-guide-modern">
                        <BiBookOpen size={18} /> {t("userGuide")}
                    </Link>
                    <LanguageSelector />
                    <div className="nav-item">
                        <button className="btn-logout-modern shadow-sm" onClick={handleLogout}>
                            <RxExit size={18} />
                            {t("logout")}
                        </button>
                    </div>
                </div>
            </header>
            <Menu show={show} toggle={toggle}/> 
        </>
    )

}

export default Header